import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import { useErrorAnimation } from '@/Pages/Error/hooks/useErrorAnimation';
import '@/Pages/Error/ErrorPage.sass';

type ErrorHeaderProps = {
  title: string;
  description: string;
};

export function ErrorHeader({ title, description }: ErrorHeaderProps): JSX.Element {
  const { reduceMotion, title: titleMotion, description: descriptionMotion } =
    useErrorAnimation();

  if (reduceMotion) {
    return (
      <Box
        component="section"
        className="error-header"
        data-testid="error-header"
        data-motion="reduced"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <Typography component="h1" className="error-header__title">
          {title}
        </Typography>
        <Typography component="p" className="error-header__description">
          {description}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      component="section"
      className="error-header"
      data-testid="error-header"
      data-motion="animated"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <Typography
        component={motion.h1}
        className="error-header__title"
        initial={titleMotion.initial}
        animate={titleMotion.animate}
        transition={titleMotion.transition}
      >
        {title}
      </Typography>
      <Typography
        component={motion.p}
        className="error-header__description"
        initial={descriptionMotion.initial}
        animate={descriptionMotion.animate}
        transition={descriptionMotion.transition}
      >
        {description}
      </Typography>
    </Box>
  );
}
